export default __webpack_public_path__ + "static/media/full_screen.f4149cdd.svg";